import { render } from "./Create.vue?vue&type=template&id=636aa3ac&bindings={\"errors\":\"props\",\"tenants\":\"props\",\"roles\":\"props\",\"form\":\"data\",\"create\":\"options\"}"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "636aa3ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('636aa3ac')) {
    api.reload('636aa3ac', script)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=636aa3ac&bindings={\"errors\":\"props\",\"tenants\":\"props\",\"roles\":\"props\",\"form\":\"data\",\"create\":\"options\"}", () => {
    api.rerender('636aa3ac', render)
  })

}

script.__file = "resources/js/Pages/Users/Create.vue"

export default script